import { useNavigate } from 'react-router-dom';
import { HomePage } from '@practium/features/home';
import { adminHomeMockData } from '../services';

export const HomePageAdmin = () => {
	const navigate = useNavigate();

	const handleNavigation = (link: string) => {
		navigate(link);
	};

	return <HomePage data={adminHomeMockData} onNavigate={handleNavigation} />;
};
